import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { Balloon, Button, DatePicker, Form, Input, Select, Table, Tag } from '@alifd/next';
import { Servlets } from '@/service';
import LzPagination from '@/components/common/LzPagination';

const SystemModel = (props) => {
  const FormItem = Form.Item;
  const { RangePicker } = DatePicker;
  const { Option } = Select;
  const { Group: TagGroup, Selectable: SelectableTag } = Tag;

  const [sign, setSign] = useState(''); // 短信签名
  // 系统模板场景
  const [scenes, setScenes] = useState(101);

  // 分页数据
  const [pageInfo, setPageInfo] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });
  // 参数
  const [missionParams, setMissionParams] = useState({
    templateType: 0, // 0-自定义模板 1-系统模板
    templateContent: '',
    templateId: '',
  });
  const [tableList, setTableList] = useState([]);
  // table loading
  const [listLoading, setListLoading] = useState(false);

  // 请求列表数据
  const getList = (params) => {
    setListLoading(true);
    Servlets('getSmsTemplate', {...params,scenes:'',status:3,modelTypeCode:props.modelTypeCode,}).then((res: { data: string }) => {
      res.data.forEach((item) => {
        item.wordCount = item.templateContent.length;
        if ((sign.length + item.wordCount + 2) <= 70) { // 短签名长度，短信内容长度，签名的【】括号长度
          item.smsNum = Math.ceil((sign.length + item.wordCount + 2) / 70);
        } else if ((sign.length + item.wordCount + 2) > 70) {
          item.smsNum = Math.ceil((sign.length + item.wordCount + 2) / 67);
        }
      });
      setTableList(res.data);
      setListLoading(false);
      setPageInfo({
        ...pageInfo,
        pageNo: res.page.pageNo,
        pageSize: res.page.pageSize,
        total: res.page.total,
      });
    }).catch(() => {
      setListLoading(false);
    });
  };


  // 表格里的操作栏
  const operate = (value, index, record) => {
    return (
      <Button
        type="primary"
        style={{ color: '#3399FF', flex: '1', textAlign: 'left' }}
        text
        onClick={() => {
          props.systemSelect(record);
        }}
      >选择
      </Button>
    );
  };

  // 分页控件切换
  const listSizeChange = (pages = {}) => {
    try {
      setPageInfo({
        ...pageInfo,
        ...pages,
      });
      const tempParams = { ...missionParams };
      tempParams.pageNo = pages.pageNo;
      tempParams.pageSize = pages.pageSize;
      getList(tempParams);
    } catch (e) {
    }
  };
  // 当sign获取完成后，再请求列表数据
  useEffect(() => {
    // 只有当sign有值才请求列表
    if (sign) {
      getList({
        ...missionParams,
        pageNo: pageInfo.pageNo,
        pageSize: pageInfo.pageSize,
        scenes,
      });
    }
  }, [sign]);

  // 当scenes变化时请求列表（但需要sign已经获取到）
  useEffect(() => {
    if (sign) {
      getList({
        ...missionParams,
        pageNo: pageInfo.pageNo,
        pageSize: pageInfo.pageSize,
        scenes,
      });
    }
  }, [scenes]);

  useEffect(() => {
    // 获取短信签名
    setListLoading(true);
    Servlets('getTitle', {}).then((res: { data: string }) => {
      const { shopName } = res.data;
      Servlets('getSmssign', { shopName }).then((res: { data: string }) => {
        setSign(res.data);
        setListLoading(false);
      }).catch((e) => {
        console.log(e);
        setListLoading(false);
      });
    });
  }, []);

  const [singleValue, setSingleValue] = useState('日常短信');

  // 标签数据
  const tagList = [
    {
      title: '日常短信',
      key: '101',
    },
    {
      title: '女神节',
      key: '102',
    },
    {
      title: '618',
      key: '103',
    },
    {
      title: '七夕',
      key: '104',
    },
    {
      title: '国庆',
      key: '105',
    },
    {
      title: '双11',
      key: '106',
    },
    {
      title: '中秋',
      key: '107',
    },
    {
      title: '双12',
      key: '108',
    },
    {
      title: '双旦节',
      key: '109',
    },
    {
      title: '年货节',
      key: '110',
    },
  ];

  return (
    <div style={{ background: 'white' }}> {/* , paddingTop: "20px" */}
      {/* 查询条件 */}
      {/* <div className="second_Tab">
        <TagGroup>
          {
            tagList.map((item, index) => {
              return <SelectableTag key={item.key}
                style={{cursor:"pointer"}}
                checked={singleValue === item.title}
                defaultChecked={true}
                // disabled={index > 2}
                onChange={() => {
                  setSingleValue(item.title)
                  setScenes(+item.key)
                  setMissionParams({
                    modelType: 2,
                    templateContent: "",
                    templateId: ""
                  })
                }}>
                {item.title}
              </SelectableTag>
            })
          }
        </TagGroup>
      </div> */}
      <div className={styles.box}>
        <Form labelAlign="left">
          <div className={styles.inputBox}>
            <div className={styles.con}>
              <FormItem label="模板ID：">
                <Input
                  placeholder="请输入模板ID"
                  aria-label="Medium"
                  aria-labelledby="J_InputMedium"
                  style={{ width: '90%', marginTop: '10px' }}
                  value={missionParams.templateId}
                  onChange={(v) => {
                    setMissionParams({ ...missionParams, templateId: v });
                  }}
                  name="templateId"
                />
              </FormItem>
            </div>
            <div className={styles.con}>
              <FormItem label="创建时间：">
                {/* <Input
                  placeholder="请输入关键字"
                  aria-label="Medium"
                  aria-labelledby="J_InputMedium"
                  style={{ width: "100%", marginTop: "10px" }}
                  value={missionParams.templateContent}
                  onChange={(v)=>{setMissionParams({...missionParams,templateContent:v})}}
                  name="templateContent" /> */}
                <RangePicker
                  className={styles.datePicker}
                  style={{ marginTop: '10px' }}
                  showTime={{ format: 'HH:mm:ss', minuteStep: 15 }}
                  name="projectSetTime"
                  followTrigger
                  autoFocus
                  popupAlign="tl bl"
                />
              </FormItem>
            </div>
            <div className={styles.CheckButtonBox} style={{ flex: 1 }}>
              <FormItem>
                <div>
                  <Form.Submit
                    validate
                    type="secondary"
                    onClick={(v, e) => {
                      getList({
                        ...missionParams,
                        templateId: missionParams.templateId ? missionParams.templateId : '',
                        templateContent: missionParams.templateContent ? missionParams.templateContent : '',
                        pageNo: 1,
                        pageSize: pageInfo.pageSize,
                        scenes,
                        createTimeStr: v.projectSetTime && v.projectSetTime.length !== 0 ? v.projectSetTime[0]._d.getTime() : '',
                        createTimeEnd: v.projectSetTime && v.projectSetTime[1] ? v.projectSetTime[1]._d.getTime() : '',
                      });
                    }}
                    style={{ marginRight: 10 }}
                  >查询
                  </Form.Submit>
                  <Form.Reset
                    style={{ width: `${90 }px` }}
                    onClick={() => {
                      setPageInfo({
                        pageNo: 1,
                        pageSize: 10,
                        total: 0,
                      });
                      getList({
                        templateType: missionParams.templateType,
                        pageNo: 1,
                        pageSize: pageInfo.pageSize,
                        scenes,
                      });
                      setMissionParams({
                        templateType: 0,
                        templateContent: '',
                        templateId: '',
                      });
                      // setScenes(101);
                      setSingleValue('日常短信');
                    }}
                  >重置
                  </Form.Reset>
                </div>
              </FormItem>
            </div>
          </div>
        </Form>
      </div>
      {/* 表格 */}
      <div className={styles.orderTable}>
        <Table dataSource={tableList} loading={listLoading} fixedHeader>
          <Table.Column title="模板ID" dataIndex="templateId" width="150px" align="left" />
          {/* <Table.Column
            title="短信场景"
            dataIndex="scenes"
            align="left"
            width="120px"
            cell={(item, index, record) => {
              return (<div>{
              record.scenes === 101 ? '日常短信' :
                record.scenes === 102 ? '女神节' :
                  record.scenes === 103 ? '618' :
                    record.scenes === 104 ? '七夕' :
                      record.scenes === 105 ? '国庆' :
                        record.scenes === 106 ? '双11' :
                          record.scenes === 107 ? '中秋' :
                            record.scenes === 108 ? '双12' :
                              record.scenes === 109 ? '双旦节' :
                                record.scenes === 110 ? '年货节' :
                                  '-'
            }
                      </div>);
            }}
          /> */}
          <Table.Column
            title="短信内容"
            align="left"
            cell={(value, index, record) => (
              <div>
                {
                (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div className={styles.limit2}>{
                      `【${sign}】${record.templateShowContent}`
                    }
                    </div>
                    <Balloon
                      align="t"
                      shouldUpdatePosition
                      closable={false}
                      trigger={<Button type="primary" style={{ color: '#3399FF', marginLeft: '4px' }} text>详情</Button>}
                    >
                      {
                        <div key={index}>
                          {`【${sign}】${record.templateShowContent}`}
                        </div>
                      }
                    </Balloon>
                  </div>
                )
              }
              </div>
            )}
          />
          {/* <Table.Column title="字数" dataIndex="wordCount" align='left' width="80px" /> */}
          <Table.Column
            title="字数/计费条数"
            align="left"
            width="160px"
            dataIndex='smsSplitNum'
            // cell={(value, index, record) => {
            //   return <div>{`${record.templateContent.length +sign.length+2} / ${record.smsNum}`}</div>;
            // }}
          />
          <Table.Column
            title="操作"
            width="80px"
            lock="right"
            cell={operate}
            align="left"
          />
        </Table>
      </div>
      <div>
        <LzPagination pageInfo={pageInfo} onChange={listSizeChange} />
      </div>
    </div>
  );
};

export default SystemModel;
